<template>
  <main class="upgrade-poster">
    <header class="kv">
      <img src="@/assets/img/banner-2026-zh-v2.jpg" alt="2026 深圳国际金融科技大赛——微众银行金融科技大学生挑战赛" />
    </header>

    <div class="poster-content">
      <section class="opening">
        <p class="eyebrow">2026 COMPETITION UPGRADE</p>
        <h1>八年积淀，<br><strong>三大升级</strong>全面启航</h1>
        <p class="opening-copy">面向金融科技、人工智能等前沿技术领域，2026 深圳国际金融科技大赛以更权威的学术支持、更开放的国际赛制和更专业的评审阵容，连接全球青年创新力量。</p>
        <div class="key-stats">
          <div><b>08</b><span>连续举办八年</span></div>
          <div><b>近万</b><span>海内外高校学子</span></div>
          <div><b>75<small>万</small></b><span>奖金池（税前）</span></div>
        </div>
      </section>

      <section class="upgrade upgrade-authority">
        <UpgradeHeading number="01" en="AUTHORITY" title="协会背书" subtitle="权威指导，专业支持全面升级" />
        <p class="upgrade-summary">本届大赛汇聚权威协会与顶尖高校力量，为赛事提供全程学术指导与专业支持。</p>
        <div class="authority-list">
          <div><i>CCF</i><span>中国计算机学会<br><b>数字金融分会</b></span></div>
          <div><i>THU</i><span>清华大学<br><b>五道口金融学院</b></span></div>
          <div><i>IEEE</i><span>计算智能学会<br><b>新加坡分会</b></span></div>
          <div><i>IEEE</i><span>计算智能学会<br><b>深圳分会</b></span></div>
        </div>
        <small class="caption">技术指导单位</small>
      </section>

      <section class="upgrade upgrade-global">
        <div class="globe-lines" aria-hidden="true"></div>
        <UpgradeHeading number="02" en="GLOBAL TRACK" title="国际赛道" subtitle="首次设立人工智能国际赛道" light />
        <p class="upgrade-summary">人工智能赛道首次采用国内、国际双轨并行。国际赛道面向海外高校在读学生，以英文为官方语言，邀请全球青年围绕“AI 金融参与者”展开创新实践。</p>
        <div class="global-features">
          <div><span>01</span><b>面向海外高校</b><p>结合 2026 年 APEC 峰会落地深圳，面向 APEC 经济体高校扩大招募</p></div>
          <div><span>02</span><b>英文官方语言</b><p>作品提交、答辩与评审均以英文进行</p></div>
          <div><span>03</span><b>全球前沿命题</b><p>探索会理解、规划并安全执行的金融 Agent</p></div>
        </div>
      </section>

      <section class="upgrade upgrade-jury">
        <UpgradeHeading number="03" en="PROFESSIONAL JURY" title="评审升级" subtitle="顶级专家参与，多元视角发现创新" />
        <p class="upgrade-summary">大赛邀请院士、国内外顶尖高校教授与金融科技行业专家担纲学术顾问和评委，从技术创新、场景价值与安全合规等维度，发现真正具有潜力的青年创新。</p>
        <div class="jury-focus">
          <div><i></i><span>学术高度</span><p>以前沿研究视野判断技术创新</p></div>
          <div><i></i><span>行业深度</span><p>以真实金融场景检验落地价值</p></div>
          <div><i></i><span>国际视角</span><p>以多元专业背景连接全球青年</p></div>
        </div>
        <div class="adviser-strip">
          <div><img src="@/assets/img/judges/汪寿阳.png" alt="汪寿阳" /><span><b>汪寿阳</b>院士专家代表</span></div>
          <div><img src="@/assets/transSave/resource/image/fa/bd/fa5b8b032b58ae82f9775f8da62636bd.png" alt="杨强" /><span><b>杨强</b>院士专家代表</span></div>
          <div><strong>10</strong><span><b>特邀学术顾问</b>汇聚国内外顶尖力量</span></div>
        </div>
      </section>

      <section class="why-join">
        <p class="eyebrow">MORE THAN A COMPETITION</p>
        <h2>为什么值得参与？</h2>
        <div>
          <p><span>01</span><b>让前沿技术走进真实金融场景</b></p>
          <p><span>02</span><b>与全球青年在同一舞台竞技交流</b></p>
          <p><span>03</span><b>让优秀作品被专业机构与行业看见</b></p>
          <p><span>04</span><b>优胜团队直通微众银行绿色面试通道</b></p>
        </div>
      </section>

      <section class="closing">
        <p>2026 FINTECHATHON</p>
        <h2>下一代金融科技，<br>等待下一代创造者</h2>
        <span>报名通道即将开放 · 敬请期待</span>
        <div><router-link to="/">了解大赛</router-link><router-link to="/rule">参赛规则</router-link></div>
      </section>
    </div>
  </main>
</template>

<script>
const UpgradeHeading = {
  props: ['number', 'en', 'title', 'subtitle', 'light'],
  render (h) {
    return h('header', { class: ['upgrade-heading', { light: this.light }] }, [
      h('span', this.number),
      h('div', [h('small', this.en), h('h2', this.title), h('p', this.subtitle)])
    ])
  }
}

export default {
  name: 'UpgradeH5',
  components: { UpgradeHeading }
}
</script>

<style lang="scss">
.upgrade-poster {
  --ink: #111b39; --blue: #3156dc; --pink: #ed315f; --cyan: #25c5eb; --violet: #7a4ddb;
  width: 100%; color: var(--ink); background: #e9edf5;
  font-family: 'Alibaba PuHuiTi 3.0', 'PingFang SC', sans-serif; overflow: hidden;
}
.upgrade-poster * { box-sizing: border-box; }
.kv, .poster-content { width: min(100%, 750px); margin: 0 auto; }
.kv { background: #03091b; }
.kv img { display: block; width: 100%; height: auto; aspect-ratio: 2 / 1; object-fit: contain; }
.poster-content {
  position: relative;
  color: #fff;
  background:
    radial-gradient(circle at 86% 12%, rgba(237,49,95,.13), transparent 19%),
    radial-gradient(circle at 8% 50%, rgba(49,86,220,.2), transparent 23%),
    radial-gradient(circle at 92% 77%, rgba(37,197,235,.1), transparent 18%),
    #050b24;
  overflow: hidden;
}
.poster-content::before {
  content: '';
  position: absolute;
  z-index: 0;
  top: 110px;
  bottom: 360px;
  left: 38px;
  width: 3px;
  border-radius: 99px;
  background: linear-gradient(180deg, var(--blue), var(--pink) 35%, var(--cyan) 68%, var(--violet));
  box-shadow: 0 0 12px rgba(86,110,255,.72);
}
.poster-content::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 0;
  opacity: .16;
  pointer-events: none;
  background-image: radial-gradient(circle, #8094dd 0 1px, transparent 1.2px);
  background-size: 46px 46px;
  mask-image: linear-gradient(#000, transparent 92%);
}
.poster-content > section { position: relative; z-index: 1; }
.eyebrow { color: var(--cyan); font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 12px; font-weight: 900; letter-spacing: .15em; }

.opening { padding: 72px 58px 78px; background: transparent; }
.opening h1 { margin-top: 18px; font-size: 44px; line-height: 1.22; letter-spacing: -.04em; }
.opening h1 strong { color: #ff6e9e; text-shadow: 0 0 18px rgba(237,49,95,.24); }
.opening-copy { margin-top: 28px; color: rgba(255,255,255,.68); font-size: 16px; line-height: 1.95; text-align: justify; }
.key-stats { display: grid; grid-template-columns: repeat(3, 1fr); margin-top: 42px; border-top: 1px solid rgba(255,255,255,.2); border-bottom: 1px solid rgba(255,255,255,.2); }
.key-stats div { padding: 24px 12px; border-right: 1px solid rgba(255,255,255,.16); }.key-stats div:last-child { border: 0; }
.key-stats b { display: block; color: #fff; font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 37px; text-shadow: 0 0 14px rgba(75,113,255,.65); }.key-stats small { font-size: .48em; }
.key-stats span { display: block; margin-top: 8px; color: rgba(255,255,255,.52); font-size: 12px; }

.upgrade { position: relative; padding: 82px 58px 88px; border-top: 1px solid rgba(255,255,255,.09); overflow: hidden; }
.upgrade::before {
  content: '';
  position: absolute;
  z-index: 3;
  top: 102px;
  left: 31px;
  width: 13px;
  height: 13px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--pink);
  box-shadow: 0 0 0 5px rgba(237,49,95,.16), 0 0 15px var(--pink);
}
.upgrade-heading { position: relative; z-index: 2; display: grid; grid-template-columns: 82px 1fr; gap: 18px; align-items: start; }
.upgrade-heading > span { color: transparent; font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 62px; font-weight: 900; line-height: .9; -webkit-text-stroke: 1px rgba(93,139,255,.66); }
.upgrade-heading small { color: var(--cyan); font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 11px; font-weight: 900; letter-spacing: .16em; }
.upgrade-heading h2 { margin-top: 4px; color: #fff; font-size: 40px; line-height: 1.15; text-shadow: 0 0 18px rgba(79,121,255,.35); }
.upgrade-heading p { margin-top: 8px; color: #ff79a5; font-size: 17px; font-weight: 700; }
.upgrade-summary { position: relative; z-index: 2; margin: 35px 0 0 100px; color: rgba(255,255,255,.68); font-size: 16px; line-height: 1.9; }

.upgrade-authority { background: transparent; }
.authority-list { position: relative; z-index: 2; display: grid; grid-template-columns: repeat(2, 1fr); margin: 42px 0 0 100px; border-top: 1px solid rgba(255,255,255,.23); }
.authority-list div { display: grid; grid-template-columns: 66px 1fr; align-items: center; min-height: 112px; border-right: 1px solid rgba(255,255,255,.15); border-bottom: 1px solid rgba(255,255,255,.17); }
.authority-list div:nth-child(2n) { padding-left: 20px; border-right: 0; }
.authority-list i { color: var(--pink); font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 18px; font-style: normal; font-weight: 900; }
.authority-list span { color: rgba(255,255,255,.5); font-size: 12px; line-height: 1.5; }.authority-list b { color: #fff; font-size: 15px; }
.caption { display: block; margin: 14px 0 0 100px; color: rgba(255,255,255,.34); font-size: 10px; text-align: right; letter-spacing: .12em; }

.upgrade-global { color: #fff; background: transparent; }
.upgrade-heading.light > span { -webkit-text-stroke-color: rgba(52,210,244,.55); }
.upgrade-heading.light small { color: var(--cyan); }.upgrade-heading.light h2 { color: #fff; }.upgrade-heading.light p { color: #ff6e9e; }
.upgrade-global .upgrade-summary { color: rgba(255,255,255,.72); }
.globe-lines { position: absolute; top: -210px; right: -270px; width: 610px; height: 610px; border: 1px solid rgba(75,205,255,.19); border-radius: 50%; box-shadow: 0 0 0 45px rgba(237,49,95,.035), 0 0 0 90px rgba(91,76,220,.035); }
.global-features { position: relative; z-index: 2; margin-top: 48px; border-top: 1px solid rgba(255,255,255,.23); }
.global-features div { display: grid; grid-template-columns: 42px 155px 1fr; align-items: center; min-height: 94px; border-bottom: 1px solid rgba(255,255,255,.17); }
.global-features span { color: #ff6999; font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 12px; font-weight: 900; }
.global-features b { font-size: 17px; }.global-features p { color: rgba(255,255,255,.55); font-size: 13px; line-height: 1.65; }

.upgrade-jury { background: transparent; }
.jury-focus { display: grid; grid-template-columns: repeat(3, 1fr); margin: 48px 0 0 100px; border-top: 1px solid rgba(255,255,255,.23); }
.jury-focus div { padding: 28px 18px; border-right: 1px solid rgba(255,255,255,.15); }.jury-focus div:last-child { border: 0; }
.jury-focus i { display: block; width: 8px; height: 8px; border-radius: 50%; background: var(--blue); box-shadow: 0 0 0 5px rgba(49,86,220,.1); }
.jury-focus span { display: block; margin-top: 20px; color: #77dfff; font-size: 16px; font-weight: 700; }.jury-focus p { margin-top: 9px; color: rgba(255,255,255,.48); font-size: 12px; line-height: 1.6; }
.adviser-strip { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 34px; }
.adviser-strip > div { min-height: 225px; border: 1px solid rgba(114,133,255,.34); background: rgba(16,27,74,.72); overflow: hidden; }
.adviser-strip img { display: block; width: 100%; height: 150px; object-fit: contain; object-position: center bottom; background: radial-gradient(circle at 50% 80%, rgba(103,86,223,.34), transparent 62%); }
.adviser-strip span { display: block; padding: 12px; color: rgba(255,255,255,.48); font-size: 10px; line-height: 1.5; }.adviser-strip span b { display: block; color: #fff; font-size: 15px; }
.adviser-strip > div:last-child { display: flex; flex-direction: column; align-items: center; justify-content: center; background: #163785; color: #fff; }
.adviser-strip strong { font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 68px; line-height: 1; }.adviser-strip > div:last-child span { color: rgba(255,255,255,.62); text-align: center; }.adviser-strip > div:last-child span b { color: #fff; }

.why-join { padding: 78px 58px; border-top: 1px solid rgba(255,255,255,.09); background: transparent; }
.why-join h2 { margin-top: 12px; font-size: 37px; }.why-join > div { margin-top: 38px; border-top: 1px solid rgba(255,255,255,.23); }
.why-join > div p { display: grid; grid-template-columns: 48px 1fr; align-items: center; min-height: 78px; border-bottom: 1px solid rgba(255,255,255,.16); }
.why-join span { color: var(--pink); font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 12px; }.why-join b { font-size: 16px; }

.closing { position: relative; min-height: 610px; padding: 108px 58px 80px; color: #fff; text-align: center; border-top: 1px solid rgba(255,255,255,.09); background: radial-gradient(circle at 50% 110%, rgba(69,106,255,.58), transparent 45%); overflow: hidden; }
.closing::before { content: ''; position: absolute; left: 50%; bottom: -360px; width: 650px; height: 650px; border: 1px solid rgba(79,121,255,.45); border-radius: 50%; box-shadow: 0 0 0 42px rgba(237,49,95,.08), 0 0 0 84px rgba(122,77,219,.06); transform: translateX(-50%); }
.closing > * { position: relative; z-index: 2; }.closing > p { color: var(--cyan); font-family: DIN-BlackItalic, DIN, sans-serif; font-size: 12px; font-weight: 900; letter-spacing: .16em; }
.closing h2 { margin-top: 25px; font-size: 43px; line-height: 1.3; }.closing > span { display: block; margin-top: 28px; color: rgba(255,255,255,.62); font-size: 14px; }
.closing > div { display: flex; justify-content: center; gap: 12px; margin-top: 48px; }.closing a { min-width: 155px; padding: 14px 20px; border: 1px solid rgba(255,255,255,.35); color: #fff; font-size: 13px; }.closing a:first-child { border-color: var(--blue); background: var(--blue); }

@media (max-width: 600px) {
  .opening, .upgrade, .why-join { padding: 54px 25px 58px; }
  .opening h1 { font-size: 34px; }.opening-copy { font-size: 15px; }
  .poster-content::before { left: 14px; top: 90px; bottom: 300px; width: 2px; }
  .key-stats { grid-template-columns: 1fr; }.key-stats div { display: grid; grid-template-columns: 105px 1fr; align-items: center; border-right: 0; border-bottom: 1px solid rgba(255,255,255,.16); }.key-stats div:last-child { border-bottom: 0; }.key-stats span { margin: 0; }
  .upgrade::before { top: 71px; left: 9px; width: 11px; height: 11px; border-width: 2px; }
  .upgrade-heading { grid-template-columns: 58px 1fr; gap: 8px; }.upgrade-heading > span { font-size: 46px; }.upgrade-heading h2 { font-size: 31px; }.upgrade-heading p { font-size: 15px; }
  .upgrade-summary, .authority-list, .caption { margin-left: 66px; }.upgrade-summary { margin-top: 28px; font-size: 15px; }
  .authority-list { grid-template-columns: 1fr; }.authority-list div, .authority-list div:nth-child(2n) { min-height: 86px; padding-left: 0; border-right: 0; }
  .global-features div { grid-template-columns: 34px 105px 1fr; min-height: 100px; }.global-features b { font-size: 15px; }.global-features p { font-size: 11px; }
  .jury-focus { grid-template-columns: 1fr; margin-left: 66px; }.jury-focus div { display: grid; grid-template-columns: 14px 82px 1fr; align-items: center; padding: 19px 3px; border-right: 0; border-bottom: 1px solid rgba(255,255,255,.16); }.jury-focus span, .jury-focus p { margin: 0; }.jury-focus p { font-size: 11px; }
  .adviser-strip { gap: 7px; }.adviser-strip > div { min-height: 183px; }.adviser-strip img { height: 115px; }.adviser-strip span { padding: 9px 7px; font-size: 8px; }.adviser-strip span b { font-size: 13px; }.adviser-strip strong { font-size: 48px; }
  .why-join h2 { font-size: 31px; }.why-join > div p { grid-template-columns: 39px 1fr; }.why-join b { font-size: 14px; }
  .closing { min-height: 540px; padding: 86px 25px 60px; }.closing h2 { font-size: 34px; }.closing > div { flex-direction: column; }
}
</style>
